import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Login_Bg from "src/assets/Login_Bg"; // Background Image
import Logo from "src/assets/Logo";
import { useSnackbar } from "src/context/ShowMessage";
import CustomLoader from "src/shared_components/CustomLoader";
import { InputField } from "src/shared_components/FormElements";
import * as yup from "yup";
import { useAuth } from "../auth/AuthContext";
import withDynamicTitle from "../hocs/withDynamicTitle";
import { LoginFormData } from "../shared_components/interfaces";
interface AuthenticationProps {}

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
    height: "100vh",
  },
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 9,
  lineHeight: 0,
  width: 250,
  height: 80,
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("lg")]: {
    alignItems: "flex-start",
  },
  // backgroundColor: "black",
  boxShadow: "-3px 7px 40px 19px #0000000D",
  borderBottomRightRadius: "49px",
}));

const Authentication: React.FC<AuthenticationProps> = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const { displayMessage } = useSnackbar();
  const isUpLg = useMediaQuery((theme: any) => theme.breakpoints.up("lg"));

  const schema = yup.object().shape({
    userName: yup.string().required("Username is required"),
    userPassword: yup.string().required("Password is required"),
  });

  const methods = useForm<LoginFormData>({
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, errors },
  } = methods;

  const onSubmit: SubmitHandler<LoginFormData> = async (data) => {
    const isSuccess: boolean | undefined = await auth.signIn(data);
    if (!!isSuccess) {
      navigate("/Dashboard");
    } else {
      displayMessage("Username or Password is not valid", "error");
    }
  };

  return (
    <RootStyle>
      <HeaderStyle>
        <Logo width={250} height={50} />
      </HeaderStyle>
      <Grid container>
        <Grid
          item
          xl={3}
          lg={3}
          md={12}
          xs={12}
          component="main"
          maxWidth="xs"
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: { lg: "5%", xs: "0%" },
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              width: "400px",
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              sx={{ color: "primary.contrastText", fontWeight: "bold" }}
            >
              Login
            </Typography>
            <Typography
              sx={{
                color: "primary.contrastText",
                fontSize: "14px",
                marginBottom: 2,
              }}
            >
              Welcome to AiRento System!
            </Typography>

            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <InputField
                  fieldName="userName"
                  label={"Username"}
                  labelColor="primary.contrastText"
                  error={!!errors?.userName}
                  control={control}
                  helperText={errors?.userName?.message}
                  fullWidth
                  other={{
                    sx: {
                      borderRadius: "8px",
                      color: "primary.contrastText",
                    },
                  }}
                  style={{ backgroundColor: "primary.contrastText" }}
                />
                <InputField
                  fieldName="userPassword"
                  label={"Password"}
                  labelColor="primary.contrastText"
                  error={!!errors?.userPassword}
                  control={control}
                  helperText={errors?.userPassword?.message}
                  fullWidth
                  style={{ backgroundColor: "primary.contrastText" }}
                  other={{
                    sx: {
                      borderRadius: "8px",
                      color: "primary.contrastText",
                    },
                    type: "password",
                  }}
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="secondary"
                  sx={{
                    fontWeight: "bold",
                    mt: 3,
                  }}
                >
                  {isSubmitting ? <CustomLoader size={30} /> : "Login ➝"}
                </Button>
              </form>
            </FormProvider>
          </Box>
        </Grid>

        {isUpLg && (
          <Grid
            xl={9}
            lg={9}
            md={12}
            xs={12}
            item
            sx={{
              // width: "35%",
              height: "100vh",
              backgroundSize: "contain",
              backgroundPosition: "center",
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              overflow: "hidden",
            }}
          >
            <Login_Bg width="100%" height="100vh" />
          </Grid>
        )}
      </Grid>
    </RootStyle>
  );
};

export default withDynamicTitle(Authentication, "Login");
